import { Box, Image, Button } from '@chakra-ui/react'
import { ArrowForwardIcon } from '@chakra-ui/icons'
import percorso_1 from '../images/PERCORSO_MAPS2.JPG'
import percorsoSat from '../images/1 percorso_SAT.jpg'
import { useNavigate } from 'react-router-dom'

const Percorso = () => {
    const navigate = useNavigate();

    const toPercorsi = () => {
        navigate("/percorso");
    }

    return (
        <Box w='100%'>
            <Box display='flex' justifyContent='center' flexDir={['column', null, 'row']} gap={[0, 0, 20]} textColor='white'>
                <Box height={['480px', null, '550px']} w={['100%', '400px', '400px']} mb={[6, null, 10]} position='relative' p={[2, 2, 4]} bgColor='green.500' borderRadius='lg'>
                    <Image
                        src={percorsoSat}
                        alt='Loading'
                        h='100%'
                        w={['100%', null, '100%']}
                        objectFit='cover'
                        borderRadius='lg'
                    />

                    <Box
                        position='absolute'
                        top={[1, 2, 2]}
                        left={[0, 2, 2]}
                        p={1}
                        // bgGradient='linear(to-r, blackAlpha.800, transparent)'
                        bg='green.500'
                        w='250px'
                        borderBottomRightRadius='lg'
                    >
                        <Box
                            fontWeight='extrabold'
                            letterSpacing='wide'
                            fontSize='xs'
                            textTransform='uppercase'
                            ml={2}
                        >
                            percorso scalette/ascensore
                        </Box>
                        <Box
                            fontWeight='semibold'
                            fontSize='xs'
                            letterSpacing='wide'
                            ml={2}
                        >
                            Via Calamo - Via Padula n.149
                        </Box>
                    </Box>
                </Box>

                <Box height={['400px', null, '550px']} w={['100%', '400px', '500px']} position='relative' textColor='white' p={[2, 2, 4]} bgColor='green.500' borderRadius='lg'>
                    <Image src={percorso_1} alt='Loading'
                        h='100%'
                        w={['100%', null, '100%']}

                        objectFit='cover'
                        borderRadius='lg'
                    />

                    <Box
                        position='absolute'
                        top={[1, 2, 2]}
                        left={[2, 2, 4]}
                        p={1}
                        // bgGradient='linear(to-r, blackAlpha.800, transparent)'
                        bg='green.500'
                        w='238px'
                        borderBottomRightRadius='lg'
                    >
                        <Box
                            fontWeight='bold'
                            letterSpacing='wide'
                            fontSize='xs'
                            textTransform='uppercase'
                        >
                            percorso passaggio pedonale
                        </Box>
                        <Box
                            fontWeight='semibold'
                            fontSize='xs'

                            letterSpacing='wide'
                        >
                            Via Calamo - angolo Via Padula n.170
                        </Box>
                    </Box>
                </Box>
            </Box>


            <Box mx='auto' textAlign='center' mt={[6, null, 10]}>
                <Button
                    bgColor='green'
                    textColor='white'
                    rightIcon={<ArrowForwardIcon />}
                    onClick={toPercorsi}
                >
                    Vai ai percorsi
                </Button>
            </Box>
        </Box>
    )
}

export default Percorso